import classNames from "classnames";
import { DateTimeFormatter, LocalDate } from "@js-joda/core";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { LOCK_SVG } from "../utils/svgs";
import { withDefault } from "../utils/withDefault";
import {
  AppCard,
  AppCardContent,
  AppCardHeader,
  AppCardSubtitle,
  AppCardTitle,
} from "./Generic/AppCard";
import { AppIcon } from "./Generic/AppIcon";
import { If } from "./Generic/If";
import { isDefined, IsDefined } from "./Generic/IsDefined";
import { RequiredDocAnswerableQuestionProps } from "./RequiredDocAnswerableQuestion";
import RequiredDocReadonlyAnswer from "./RequiredDocReadonlyAnswer";

type Props = RequiredDocAnswerableQuestionProps;

const formatterLocalDate = DateTimeFormatter.ofPattern("MM/dd/yyyy");

const RequiredDocDate = (props: Props) => {
  const formatAnswer = (answer: Props["currentAnswer"]) => {
    const stringAnswer = Array.isArray(answer) ? answer[0] : answer;
    return isDefined(stringAnswer)
      ? LocalDate.parse(stringAnswer).format(formatterLocalDate)
      : stringAnswer;
  };

  const onChangeAnswer = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value.trim() === "" ? null : e.currentTarget.value.trim();
    props.handleOnInsertAnswer(props.questionId, value);
  };

  return (
    <AppCard
      className={classNames({ __invalid: !props.isValid })}
      onClick={() => {
        if (props.readonly && props.onClickWhileDisabled !== undefined) {
          props.onClickWhileDisabled();
        }
      }}
    >
      <AppCardHeader>
        <AppCardTitle className="flex justify-space-between full-width">
          <>
            {props.questionText}
            <If condition={props.isRequired && !props.readonly}>
              <span className="__badge">{translate(STRINGS.REQUIRED)}</span>
            </If>
          </>
          <If condition={props.readonly}>
            <AppIcon icon={LOCK_SVG} fill="gray" size={16} />
          </If>
        </AppCardTitle>
        <IsDefined value={props.notes}>
          {(notes) => <AppCardSubtitle>{`${translate(STRINGS.NOTES)}: ${notes}`}</AppCardSubtitle>}
        </IsDefined>
      </AppCardHeader>
      <AppCardContent>
        {props.readonly ? (
          <RequiredDocReadonlyAnswer currentAnswer={formatAnswer(props.currentAnswer)} />
        ) : (
          <input
            type="date"
            disabled={props.readonly}
            className="ScheduledVisitDocScreen__margin ScheduledVisitDocScreen__block text-input text-input--material"
            onChange={onChangeAnswer}
            value={withDefault(props.currentAnswer, "")}
          />
        )}
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(RequiredDocDate);
